import { useUserPreferences } from '@/stores/database/entities/00-RBAC/99-UserPreferences';

type PreferenceValidator<T> = (value: unknown) => value is T;

export const useFinancialOverviewViewPreference = <T>(
    preferenceKey: string,
    setting: string,
    defaultValue: T,
    isValid: PreferenceValidator<T>,
) => {
    const { preferences, setPreference } = useUserPreferences();
    const storedValue = (
        preferences?.financialOverview as
            | {
                  views?: Record<string, Record<string, unknown>>;
              }
            | undefined
    )?.views?.[preferenceKey]?.[setting];
    const value = isValid(storedValue) ? storedValue : defaultValue;

    const setValue = (nextValue: T) => {
        setPreference(`financialOverview.views.${preferenceKey}.${setting}`, nextValue);
    };

    return [value, setValue] as const;
};
